import React from "react";
import { BENEFITS } from "../mock";

const LeafIcon = () => (
  <svg width="38" height="38" viewBox="0 0 56 56" className="mx-auto">
    <path
      d="M28 10 C18 16, 14 28, 22 40 C18 32, 22 22, 28 18 C34 22, 38 32, 34 40 C42 28, 38 16, 28 10 Z"
      fill="#c8232c"
    />
  </svg>
);

const Benefits = () => {
  const left = BENEFITS.slice(0, 3);
  const right = BENEFITS.slice(3, 6);

  return (
    <section id="benefits" className="py-20 lg:py-28 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <LeafIcon />
          <h2 className="font-display text-4xl md:text-5xl text-[#c8232c] mt-4">
            The benefits of nuts
          </h2>
          <div className="nut-divider" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-10 md:gap-6 items-center">
          <div className="space-y-12">
            {left.map((b) => (
              <div key={b.n} className="md:text-right">
                <div className="benefit-num md:ml-auto" style={{ background: b.color }}>
                  {b.n}
                </div>
                <h3 className="font-display text-2xl text-stone-800 mt-4">{b.title}</h3>
                <p className="text-stone-600 text-sm mt-2 leading-relaxed max-w-sm md:ml-auto">
                  {b.text}
                </p>
              </div>
            ))}
          </div>

          <div className="hidden md:block w-[260px] lg:w-[320px]">
            <img
              src="https://images.unsplash.com/photo-1549978113-29eb25c8177f?w=900&q=80"
              alt="Nuts"
              className="w-full h-auto"
            />
          </div>

          <div className="space-y-12">
            {right.map((b) => (
              <div key={b.n}>
                <div className="benefit-num" style={{ background: b.color }}>
                  {b.n}
                </div>
                <h3 className="font-display text-2xl text-stone-800 mt-4">{b.title}</h3>
                <p className="text-stone-600 text-sm mt-2 leading-relaxed max-w-sm">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
